var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCg = function SvgCg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    fillRule: "evenodd",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBDE4A",
    fillRule: "evenodd",
    d: "M16.94 1.06C21.101 2.944 24 7.135 24 12c0 6.627-5.373 12-12 12-4.866 0-9.057-2.897-10.94-7.06L16.94 1.06Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC241F",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12 0-1.76-.379-3.433-1.06-4.94L7.06 22.94A11.958 11.958 0 0 0 12 24Z",
    clipRule: "evenodd"
  })));
};
export default SvgCg;